module.exports = [{"id":"avmed","name":"Avmed"},{"id":"humana","name":"Humana"}]


//////////////////
// WEBPACK FOOTER
// ./src/config/themes.json
// module id = 341
// module chunks = 0